import { useRouter } from "next/router";

export function useContentPageRouteValues() {
  const router = useRouter();

  if (!router.isReady) {
    return {
      loading: true,
      organizationExternalId: null,
      pageSlug: null,
      spaceExternalId: undefined,
    };
  }

  const rawSpaceExternalId = router.query.space_external_id;

  return {
    loading: false,
    organizationExternalId: router.query.organizationExternalId as string,
    pageSlug: router.query.pageSlug as string,
    spaceExternalId: Array.isArray(rawSpaceExternalId)
      ? rawSpaceExternalId[0]
      : rawSpaceExternalId,
  };
}
